import * as yup from "yup";
import Form, { FormField, FormFieldGroup, FormGroup, FormObject, FormOptions } from "../components/form/form.component";
import { useTranslation } from "react-i18next";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { handleReCaptchaVerifyUtil } from "@functions/reacptchaCallback";
import { useCallback, useEffect, useState } from "react";
import { Box, Grid, useTheme } from "@mui/material";
import Title, { TitleProps } from "../components/title/title.component";
import RegisterService from "@services/register-service";
import NetnutSwitch from "@global/switch/switch.component";
import { setAffiliateData } from "../functions";
import { useLocation } from "react-router";
import CustomerService from "@services/customer-service";
import { setCustomer, setToken } from "@store/account/account.slice";
import { useDispatch } from "react-redux";
import { logged } from "@store/theme/theme.slice";
export interface RegisterNewSetp2CompanyValues {
  companyName: string;
  companyWebsite: string;
}

export interface RegisterNewSetp2CustomerUsageDescriptionValues {
  industry: string;
  products: string[] | string;
  estimatedBandwidth: string;
  plannedUsageDescription: string;
}
class RegisterNewSetp2CompanyObject extends FormObject<RegisterNewSetp2CompanyValues> {
  companyName: FormField;
  companyWebsite: FormField;

  constructor(options: FormOptions<RegisterNewSetp2CompanyValues> | null) {
    if (options) super(options);
    else super(null);
    this.companyName = { name: "companyName", displayName: "Company Name", type: "text" };
    this.companyWebsite = { name: "companyWebsite", displayName: "Company website", type: "text" };
  }
  static getInitialValuesStatic(): RegisterNewSetp2CompanyValues {
    return new RegisterNewSetp2CompanyObject(null).getInitialValues();
  }
}

class RegisterNewSetp2CustomerUsageDescriptionObject extends FormObject<RegisterNewSetp2CustomerUsageDescriptionValues> {
  industry: FormField;
  products: FormField;
  estimatedBandwidth: FormField;
  plannedUsageDescription: FormField;

  constructor(options: FormOptions<RegisterNewSetp2CustomerUsageDescriptionValues> | null) {
    if (options) super(options);
    else super(null);
    this.industry = {
      name: "industry",
      displayName: "Industry",
      type: "select",
      select: {
        title: "Choose Industry",
        values: [
          "Other",
          "Affiliate",
          "eCommerce",
          "Price Comparison",
          "SEO",
          "Web data extraction",
          "coinlist",
          "Re-Seller",
          "Ticketing",
          "Travel",
          "Social Media",
          "Sneakers",
          "Instagram",
          "Affiliation",
          "Google",
          "Brand Protection",
          "Ad verification",
          "Sales Intelligence",
          "Financial Technologies",
          "Retail",
          "Self Test",
          "Automotive",
          "Banking",
          "Sports Betting",
          "Real Estate",
          "Talent Sourcing",
          "People Data",
          "Insurance",
          "Online Casino",
          "ISP",
          "Health Care",
          "Craigslist",
          "VPN",
          "Gaming",
          "Cyber Security",
          "Digital Marketing",
          "Email Verification",
          "Research Institution",
          "Intelligence Agency",
          "Automated Data Collection",
          "Traveling",
          "Trial",
        ],
      },
      size: 4,
      margin: 2,
    };
    this.products = { name: "products", displayName: "Requierd products", type: "select", select: { title: "Choose your requierd products", values: ["Datacenter IPs", "Rotating Residental IPs", "Static Residental IPs", "Mobile IPs"], multiple: true }, size: 4, margin: 2 };
    this.estimatedBandwidth = { name: "estimatedBandwidth", displayName: "Estimated bandwidth", type: "select", select: { title: "Choose your estimated bandwidth", values: ["1T+", "500GB-1T", "100GB-500GB", "50GB-100GB", "10GB-50GB", "1GB-9GB"] }, size: 4, margin: 2 };
    this.plannedUsageDescription = { name: "customerDescription", displayName: "Please discribe in detail how you plan to use netnut", type: "text", text: { fullWidth: true, multiLine: true, rows: 7 }, margin: 1 };
  }
  static getInitialValuesStatic(): RegisterNewSetp2CustomerUsageDescriptionValues {
    return new RegisterNewSetp2CustomerUsageDescriptionObject(null).getInitialValues();
  }
  getGroups(): FormGroup {
    const left: FormFieldGroup = { direction: "column", values: [this.industry, this.products, this.estimatedBandwidth], name: "customer-data-selects" };
    const right: FormFieldGroup = { direction: "column", values: [this.plannedUsageDescription], name: "customer-usage-description" };
    return { container: "row", groups: [left, right] };
  }
}
export interface RegisterNewStep2Props {
  goToNextStep: () => void;
}
const RegisterNewStep2 = (props: RegisterNewStep2Props) => {
  const { t } = useTranslation();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const handleReCaptchaVerify = handleReCaptchaVerifyUtil(useCallback, executeRecaptcha);
  const theme = useTheme();
  const { search } = useLocation();
  const dispatch = useDispatch();

  const [isCompany, setIsCompany] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      const response = await CustomerService.isDisposable({
        email:"asd@netnut.io",
        reToken: await handleReCaptchaVerify(),
      });
      setIsCompany(response.data[0].exists);
    })();
  }, []);
  const titlePropsCompany: TitleProps = { title: "Company information", subTitle: "This information will be used for all the platform actions" };
  const titlePropsCustomerUsageDescription: TitleProps = { title: "Usage Description", subTitle: "This information will be used for all the platform actions" };

  const validationSchemaCompany: yup.ObjectSchema<yup.AnyObject, yup.AnyObject, yup.AnyObject, ""> = yup.object({
    companyName: yup.string().trim().required(t("Company name is required")!),
    companyWebsite: yup.string().trim().matches(/((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/g,"Enter correct URL").required(t("Company website is required")!),
  });
  const validationSchemaCustomerUsageDescription: yup.ObjectSchema<yup.AnyObject, yup.AnyObject, yup.AnyObject, ""> = yup.object({
    industry: yup.string().required(t("Industry is required")!),
    products: yup.array().of(yup.string()).required(t("Products are is required")!),
    estimatedBandwidth: yup.string().required(t("Estimated Bandwidth is required")!),
    customerDescription: yup.string().trim().required(t("Planned Usage Description is required")!),
  });

  const [formValuesCompany, setFormValuesCompany] = useState<RegisterNewSetp2CompanyValues>(RegisterNewSetp2CompanyObject.getInitialValuesStatic());
  const [formValuesCustomerUsageDescription, setFormValuesCustomerUsageDescription] = useState<RegisterNewSetp2CustomerUsageDescriptionValues>(RegisterNewSetp2CustomerUsageDescriptionObject.getInitialValuesStatic());
  const [isFormValidCompany, setIsFormValidCompany] = useState<boolean>(false);
  const [isFormValidCustomerUsageDescription, setIsFormValidCustomerUsageDescription] = useState<boolean>(false);
  const onSubmitForm = async () => {
    const response = await new RegisterService().registerForm2(formValuesCompany, formValuesCustomerUsageDescription, setAffiliateData(search), isCompany, await handleReCaptchaVerify());
    if(response.success){
      dispatch(setToken(sessionStorage.getItem("tempToken") as string));
      dispatch(setCustomer(JSON.parse(sessionStorage.getItem("tempCust") as string)));
      dispatch(logged(true));
      location.href = "/thank-you";
    }
 
  };

  const registerNewStep2CustomerUsageDescriptionObject = new RegisterNewSetp2CustomerUsageDescriptionObject({
    formName: "register-step-2-customer-usage-uescription",
    otp: {
      isOtp: false,
      email: "",
    },
    submit: {
      isSubmitActive: true,
      isSubmitApproved: (isFormValidCompany && isFormValidCustomerUsageDescription) || (!isCompany && isFormValidCustomerUsageDescription),
      onSubmit: onSubmitForm,
    },
    goToNextStep: props.goToNextStep,
    setIsFormValid: setIsFormValidCustomerUsageDescription,
    validationSchema: validationSchemaCustomerUsageDescription,
    setFormValues: setFormValuesCustomerUsageDescription,
  });
  const registerNewStep2CompanyObject = new RegisterNewSetp2CompanyObject({
    formName: "register-step-2-company",
    otp: {
      isOtp: false,
      email: "",
    },
    submit: {
      isSubmitActive: false,
    },
    setIsFormValid: setIsFormValidCompany,
    validationSchema: validationSchemaCompany,
    setFormValues: setFormValuesCompany,
  });
  return (
    <Box
      style={{
        backgroundColor: theme.palette.background.paper,
        padding: "14px",
      }}
    >
      <Grid container>
        <Grid sx={{ marginRight: "85px" }}>
          <Title {...titlePropsCompany} />
        </Grid>
        <NetnutSwitch label="Are you a company" setState={setIsCompany} />
      </Grid>
      {isCompany && <Form key={"form-1"} {...registerNewStep2CompanyObject.getProps()} />}
      <Title {...titlePropsCustomerUsageDescription}></Title>
      <Form key={"form-2"} {...registerNewStep2CustomerUsageDescriptionObject.getProps()} group={registerNewStep2CustomerUsageDescriptionObject.getGroups()}></Form>
    </Box>
  );
};
export default RegisterNewStep2;
